"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETRIEVE_ACCESS_TOKENS_FAIL = void 0;
exports.RETRIEVE_ACCESS_TOKENS_FAIL = 'Full authentification is required to access this resource';
